export const isToRepair = (clothes) => {
  const selectedProblemsKeys = clothes.flatMap((cloth) => Object.keys(cloth.selectedProblems || {}).concat(cloth.suitProblems || []));
  const filterDamaged = selectedProblemsKeys.filter((key) => !key.includes('_multiple') && !key.includes('damaged'));
  return filterDamaged.length <= 0;
};
